import React from "react";
import { NetworkIconContainer } from "./NetworkIconStyled";

export default function TwitterIcon() {
    return (
        <NetworkIconContainer>
            <svg xmlns="http://www.w3.org/2000/svg" width="39.581" height="32.147" viewBox="0 0 39.581 32.147" >
                <path id="Icon_awesome-twitter" data-name="Icon awesome-twitter" d="M35.513,11.392c.025.352.025.7.025,1.055,0,10.724-8.162,23.081-23.081,23.081A22.924,22.924,0,0,1,0,31.887a16.782,16.782,0,0,0,1.959.1A16.246,16.246,0,0,0,12.03,28.521,8.127,8.127,0,0,1,4.445,22.9a10.23,10.23,0,0,0,1.532.126,8.58,8.58,0,0,0,2.135-.276,8.113,8.113,0,0,1-6.5-7.962v-.1a8.17,8.17,0,0,0,3.667,1.03A8.124,8.124,0,0,1,2.763,4.863a23.059,23.059,0,0,0,16.727,8.489,9.158,9.158,0,0,1-.2-1.858,8.12,8.12,0,0,1,14.039-5.55,15.971,15.971,0,0,0,5.149-1.959,8.09,8.09,0,0,1-3.566,4.47A16.263,16.263,0,0,0,39.581,7.2a17.438,17.438,0,0,1-4.069,4.194Z" transform="translate(0 -3.381)" fill="#fff" />
            </svg>
        </NetworkIconContainer>
    )
}